define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/locale",
	"csi/comm/PostRequest",
	"csi/widget/MessageDialog",
], function(declare,lang,Controller,locale,PostRequest,MessageDialog) {

return declare(Controller, {
		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;

			this.setProgress();

			var postRequest = new PostRequest(req.m_module, req.m_operation);

			if (this.m_urlNode) {
				postRequest.addParameter("URL", this.m_urlNode);
			}

			postRequest.post({}).then(lang.hitch(this, this._onPublishResponse));

		},

		// Updates the success response
		getStringParameters: function() {
			var	v = this.m_response;
			return v ? [v.getResultNode().successCount] : null;
		},

		// post process success m_response
		postProcessSuccess: function() {
			var	v = this.m_response;
			var syncReport = v.getResultNode();

			if (!syncReport || syncReport.failureCount == 0){
				return;
			}

			var total = syncReport.failureCount + syncReport.successCount;
			var msgtxt = locale.resource("SynchronizeLdapServerWarning", [syncReport.successCount, total]);
			var title = locale.resource("SynchronizeLdapServerTitle");

			syncReport.messageArray.forEach(errMsg => msgtxt += locale.resource(errMsg));

			new MessageDialog({
				buttons: [MessageDialog.BUTTON_OK],
				materialIcon: MessageDialog.ICON_WARNING,
				message: msgtxt,
				title: title
			}).show();
		}
	});
});